import { Button, Space, Tag } from "antd";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

export default function FilterPresets({ page, onApplyPreset, selectedPreset }) {
  const { t } = useTranslation();

  // الفلاتر الافتراضية حسب الصفحة
  const getDefaultPresets = () => {
    const today = dayjs();
    const yesterday = today.subtract(1, "day");
    const lastWeek = today.subtract(7, "days");
    const lastMonth = today.subtract(30, "days");
    const last3Months = today.subtract(90, "days");

    const commonPresets = [
      {
        id: "today",
        name: t("common.today"),
        filters: [
          {
            field: "startDate",
            value: today.format("YYYY-MM-DD"),
          },
          {
            field: "endDate",
            value: today.format("YYYY-MM-DD"),
          },
        ],
      },
      {
        id: "yesterday",
        name: t("common.yesterday"),
        filters: [
          {
            field: "startDate",
            value: yesterday.format("YYYY-MM-DD"),
          },
          {
            field: "endDate",
            value: yesterday.format("YYYY-MM-DD"),
          },
        ],
      },
      {
        id: "lastWeek",
        name: t("common.lastWeek"),
        filters: [
          {
            field: "startDate",
            value: lastWeek.format("YYYY-MM-DD"),
          },
          {
            field: "endDate",
            value: today.format("YYYY-MM-DD"),
          },
        ],
      },
      {
        id: "lastMonth",
        name: t("common.lastMonth"),
        filters: [
          {
            field: "startDate",
            value: lastMonth.format("YYYY-MM-DD"),
          },
          {
            field: "endDate",
            value: today.format("YYYY-MM-DD"),
          },
        ],
      },
      {
        id: "last3Months",
        name: t("common.last3Months"),
        filters: [
          {
            field: "startDate",
            value: last3Months.format("YYYY-MM-DD"),
          },
          {
            field: "endDate",
            value: today.format("YYYY-MM-DD"),
          },
        ],
      },
    ];

    // فلاتر خاصة حسب الصفحة
    const pageSpecificPresets = {
      lead: [
        {
          id: "pending",
          name: t("common.pendingLeads"),
          filters: [
            {
              field: "leadStatus",
              value: "pending",
            },
          ],
        },
        {
          id: "new",
          name: t("common.newLeads"),
          filters: [
            {
              field: "leadStatus",
              value: "new",
            },
          ],
        },
      ],
      contact: [
        {
          id: "active",
          name: t("common.activeContacts"),
          filters: [
            {
              field: "status",
              value: "true",
            },
          ],
        },
      ],
      company: [
        {
          id: "active",
          name: t("common.activeCompanies"),
          filters: [
            {
              field: "status",
              value: "true",
            },
          ],
        },
      ],
    };

    return [...commonPresets, ...(pageSpecificPresets[page] || [])];
  };

  const presets = getDefaultPresets();

  if (presets.length === 0) {
    return null;
  }

  return (
    <div>
      <h3 className="mb-2 font-semibold">{t("common.defaultFilters")}</h3>
      <Space wrap>
        {presets.map((preset) => (
          <Button
            key={preset.id}
            size="small"
            type={selectedPreset?.id === preset.id ? "primary" : "default"}
            onClick={() => onApplyPreset(preset)}>
            {preset.name}
          </Button>
        ))}
      </Space>
    </div>
  );
}
